import { ChangelogEntry } from "./changelog"

export const getLatestChangelogId = (): number => CHANGELOG_DATA[0]?.id || 0

export const CHANGELOG_DATA: ChangelogEntry[] = [
     {
          id: 7,
          version: "v8.6.0",
          date: "26/08/2026",
          title: "Documents d'embauche : envoi et gestion",
          changes: {
               feature: [
                    {
                         text: "Envoi des documents d'embauche au nouveau collaborateur : depuis une demande d'embauche (une fois l'espace de travail en configuration) ou depuis l'onglet Documents de sa fiche, les documents du dossier de son entité sont envoyés à son adresse e-mail personnelle, avec la possibilité d'y joindre le contrat de travail. Aperçu de chaque document, téléchargement en ZIP, et contrôle de la taille totale pour respecter la limite des pièces jointes e-mail (9,5 Mo).",
                         tags: ["Staff", "Embauche", "Documents"],
                    },
                    {
                         text: "Gestion des documents d'embauche directement dans l'application (menu Base documentaire), organisés par entité puis par statut (ETAM / Cadre) : ajout de plusieurs fichiers à la fois (chacun avec son titre, pré-rempli à partir du nom du fichier), renommage, remplacement, suppression définitive, aperçu et recherche par entité ou par document. Accès réservé par une permission dédiée.",
                         tags: ["Base documentaire", "Documents"],
                         issues: [894],
                    },
                    {
                         text: "Nouvel onglet « Activité » sur la fiche d'un staff, regroupant ses déclarations d'activité, ses arrêts maladie et ses demandes de congés (les déclarations quittent l'onglet Documents). Les demandes de congés peuvent y être validées ou rejetées directement par le responsable hiérarchique, comme dans la liste des validations de congés.",
                         tags: ["Staff", "Congés", "Absences"],
                         issues: [898],
                    },
                    {
                         text: "Ajouter un staff — préremplissage automatique : à la première étape, téléversez (par clic ou glisser-déposer) l'Attestation de Sécurité Sociale, le Passeport / la Carte d'identité ou le CV pour remplir automatiquement les champs correspondants (n° de sécurité sociale ; civilité, nom, prénom, date et pays de naissance, nationalité ; adresse, ville, code postal, téléphone et e-mail personnels). Seuls les champs vides sont remplis, tout reste modifiable, et les documents sont ajoutés à l'onglet Documents. La photo accepte aussi le glisser-déposer.",
                         tags: ["Staff", "Embauche", "Documents"],
                         issues: [910],
                    },
                    {
                         text: "Fiche staff — le panneau latéral affiche le « N° immat. CEGEDIM » (salariés) et le « Code analytique » (salariés & non salariés), consultables et modifiables par les gestionnaires du staff (le n° CEGEDIM ne peut être défini qu'une seule fois). Nouvel onglet « Suivi » (également repris dans les Paramètres du compte) : le journal des actions effectuées sur le collaborateur — modifications d'informations personnelles, du code analytique, du n° CEGEDIM, envois de documents. Chaque modification des informations personnelles est notifiée par e-mail à l'équipe administrative.",
                         tags: ["Staff", "Fiche"],
                         issues: [913],
                    },
               ],
               improvement: [
                    {
                         text: "Fiche staff — les responsables disposant du droit « manager » peuvent désormais consulter et modifier les Informations personnelles d'un collaborateur de leur périmètre, comme les gestionnaires complets et restreints (le n° immat. CEGEDIM et le code analytique restent réservés à ces derniers).",
                         tags: ["Staff", "Droits"],
                         issues: [914],
                    },
               ],
               fix: [
                    {
                         text: "Espace collaborateur (Talent) : dans « Mes documents », les documents d'embauche s'affichent désormais avec leur titre plutôt que le nom du fichier.",
                         tags: ["Talent", "Documents"],
                         issues: [894],
                    },
                    {
                         text: "Calculateur / simulation de rentabilité : correction d'une erreur qui empêchait le calcul de s'afficher (500) après la mise à jour technique du framework.",
                         tags: ["Outils", "Calculateur"],
                         issues: [907],
                    },
                    {
                         text: "Documents d'un collaborateur (staff) : correction du téléchargement des pièces (CV, pièce d'identité, attestation, RIB, contrat…) qui échouait avec « Ce document n'existe pas ».",
                         tags: ["Staff", "Documents"],
                         issues: [911],
                    },
                    {
                         text: "Fiche staff — le code postal de résidence saisi dans « Informations personnelles » est désormais correctement enregistré.",
                         tags: ["Staff"],
                         issues: [915],
                    },
               ],
          },
          internal: {
               functional: [
                    {
                         text: "Embauche staff — créateur RH : contrat de travail obligatoire, libellé d'état et e-mail de validation DG adaptés lorsque le créateur est lui-même RH.",
                         tags: ["Staff", "Embauche"],
                         issues: [888],
                    },
                    {
                         text: "Embauche staff — nouveau contrat « Alternance » (avec présélection « École ») et diplôme obligatoire par défaut, avec case « ce collaborateur n'a pas de diplôme ».",
                         tags: ["Staff", "Embauche"],
                         issues: [889],
                    },
                    {
                         text: "Métiers du personnel interne — suppression douce, ordre et exclusion des catégories ; libellé « Lieu de travail ».",
                         tags: ["Staff", "Métiers"],
                         issues: [890],
                    },
                    {
                         text: "Fiche demande d'embauche — correctif d'upload concurrent de documents et impression du dossier complet en PDF.",
                         tags: ["Staff", "Embauche", "Documents"],
                         issues: [891],
                    },
                    {
                         text: "Documents d'embauche — alerte sur le tableau de bord et relance automatique (planificateur) des documents non encore envoyés aux staff.",
                         tags: ["Staff", "Documents"],
                         issues: [895],
                    },
                    {
                         text: "Demande d'embauche — workflow lorsque le créateur est un DG (soumission directe aux RH, rectification simplifiée, e-mails dédoublonnés).",
                         tags: ["Staff", "Embauche"],
                         issues: [896],
                    },
                    {
                         text: "Demande d'embauche — corrections et confort d'usage (redirection après la 1re étape, e-mails de finalisation, loaders sur les actions).",
                         tags: ["Staff", "Embauche"],
                         issues: [897],
                    },
                    {
                         text: "Demande d'embauche — les documents ajoutés ou remplacés dans une demande sont désormais automatiquement partagés (Google Drive) avec la hiérarchie du créateur de la demande et l'équipe administrative.",
                         tags: ["Staff", "Embauche", "Documents"],
                         issues: [909],
                    },
                    {
                         text: "Ajouter un staff — le sélecteur « Métier » affiche la catégorie Commerciale dans l'ordre hiérarchique voulu (Ingénieur d'affaires, Responsable d'activité, Responsable de département, Directeur d'agence, Gérant) plutôt qu'alphabétique.",
                         tags: ["Staff", "Métiers"],
                         issues: [912],
                    },
                    {
                         text: "Mes Indicateurs — détail de la rentabilité par mois (réservé aux super-administrateurs) : un clic sur un mois du graphe ouvre une modale à deux onglets, AT (par consultant) et Forfait (par PTF), avec responsable, charges, CA, liens vers les fiches, respect du mode Mensuel/Cumulé, recherche et totaux. Le champ « Responsables » liste désormais l'ensemble du staff pour un super-administrateur.",
                         tags: ["Tableau de bord", "Indicateurs", "Rentabilité"],
                         issues: [908],
                    },
               ],
               technical: [
                    {
                         text: "Agence — renommage interne CODE_AGENCE_SIEGE → CODE_AGENCE_BORDEAUX.",
                         tags: ["Technique"],
                         issues: [892],
                    },
                    {
                         text: "Infrastructure : migration de toute la production vers un serveur unique (DNS + certificats HTTPS pour agora → structure, talent, api-core, logs, cts-corporate.com/www, vcf, pdf-utils) ; agora.cts-corporate.com conservé en redirection ; anciens serveurs décommissionnés.",
                         tags: ["Technique", "Infrastructure"],
                         issues: [900],
                    },
                    {
                         text: "Migration de GlitchTip (logs.cts-corporate.com) vers le nouveau serveur, avec reprise complète des données (événements, projets, utilisateur) et de la configuration.",
                         tags: ["Technique", "Infrastructure"],
                         issues: [901],
                    },
                    {
                         text: "Suppression du service api-utils inutilisé (fusion PDF morte) côté api-core.",
                         tags: ["Technique"],
                         issues: [902],
                    },
                    {
                         text: "Signatures Gmail : logo désormais servi par api-core (hôte stable) ; anciennes signatures maintenues via redirection.",
                         tags: ["Technique", "Emails"],
                         issues: [903],
                    },
                    {
                         text: "Talent : autorisation de l'affichage en iframe depuis le site cts-corporate.com (en-tête CSP).",
                         tags: ["Technique", "Talent"],
                         issues: [904],
                    },
                    {
                         text: "pdf-utils (Stirling-PDF) migré vers le nouveau serveur et mis à jour (v2.14.3) ; chaîne de build/déploiement CI rétablie.",
                         tags: ["Technique", "Infrastructure"],
                         issues: [905],
                    },
               ],
          },
     },
     {
          id: 6,
          version: "v8.5.0",
          date: "19/08/2026",
          title: "Embauche d'un staff : parcours de A à Z",
          changes: {
               feature: [
                    {
                         text: "Nouveau parcours d'embauche d'un staff : la demande se remplit en plusieurs étapes (identité & contact, poste & organisation, temps, documents), puis passe en validation à la Direction, aux RH, et enfin en finalisation par l'administration (droits, carte NFC, co-équipiers, compte Google). Suivi de l'avancement, notifications par e-mail à chaque étape, et reprise possible d'un brouillon.",
                         tags: ["Staff", "Embauche"],
                         issues: [875],
                    },
                    {
                         text: "Dépôt des pièces justificatives par glisser-déposer (CV, pièce d'identité, attestation de Sécurité Sociale, RIB, titre de séjour, diplômes…), avec remplacement et ajout multiple ; contrôle de complétude détaillé avant de pouvoir soumettre la demande.",
                         tags: ["Staff", "Documents"],
                         issues: [875],
                    },
                    {
                         text: "Embauche d'un staff non salarié (portage, freelance, société de services) : sélection du fournisseur et de son contact, détails société, taux journalier HT et dépôt des documents du fournisseur (KBIS, RC Pro, Vigilance URSSAF, régularité fiscale, RIB). Le parcours non salarié est finalisé dès la validation de la Direction.",
                         tags: ["Staff", "Embauche", "Non salarié"],
                         issues: [877],
                    },
                    {
                         text: "Onglet Documents de la fiche staff : ajout, remplacement et suppression des pièces administratives d'un staff déjà intégré (documents du staff et, pour un non salarié, documents du fournisseur). Un document supprimé est masqué de la fiche mais conservé.",
                         tags: ["Staff", "Documents"],
                         issues: [879],
                    },
               ],
               fix: [
                    {
                         text: "Correction du champ « Métier » qui pouvait s'afficher vide à la reprise d'une demande (sélecteur groupé par catégorie).",
                         tags: ["Staff"],
                         issues: [876],
                    },
                    {
                         text: "Correction d'une erreur qui empêchait de finaliser l'embauche d'un staff non salarié.",
                         tags: ["Staff", "Embauche"],
                         issues: [883],
                    },
                    {
                         text: "Correction d'un plantage de l'organigramme lorsqu'un collaborateur n'avait pas de poste renseigné.",
                         tags: ["Organigramme"],
                         issues: [884],
                    },
               ],
          },
          internal: {
               functional: [
                    {
                         text: "Finalisation embauche staff — envoi des identifiants Google au créateur et confirmation en modale.",
                         tags: ["Staff", "Embauche", "Google Workspace"],
                         issues: [885],
                    },
                    {
                         text: "Fiche staff — validation de la ville de résidence (France) à l'édition des informations personnelles.",
                         tags: ["Staff"],
                         issues: [886],
                    },
                    {
                         text: "Changement d'utilisateur (impersonation) instantané avec modale, et en-tête responsive.",
                         tags: ["Administration"],
                         issues: [887],
                    },
               ],
          },
     },
     {
          id: 5,
          version: "v8.4.0",
          date: "17/08/2026",
          title: "Cycle de vie du staff : arrivée & départ",
          changes: {
               feature: [
                    {
                         text: "Le siège peut désormais gérer le staff de CTS directement depuis Agora, avec des accès adaptés à chaque profil (gestion complète ou consultation simple)",
                         tags: ["Staff"],
                         issues: [872],
                    },
                    {
                         text: "Sortir un staff des effectifs : réaffectation complète du périmètre (consultants, propositions, annonces, viviers) à un nouveau responsable, réécriture de la hiérarchie et repartage des fichiers Drive",
                         tags: ["Staff", "Départ"],
                         issues: [853, 860],
                    },
                    {
                         text: "Changement de mot de passe imposé lors de la première connexion ou après un mot de passe provisoire",
                         tags: ["Sécurité"],
                         issues: [857],
                    },
               ],
               improvement: [
                    {
                         text: "Candidature sur une offre archivée : message affiché au candidat reformulé de façon plus professionnelle",
                         tags: ["Recrutement"],
                         issues: [845],
                    },
               ],
               fix: [
                    {
                         text: "Extraction des factures : correction d'un cas où un PDF multi-factures pouvait être traité silencieusement comme vide (réponse de l'IA tronquée)",
                         tags: ["Déclarations", "IA"],
                         issues: [846],
                    },
                    {
                         text: "Correction du blocage des saisies de CRA à partir de 2025 (date limite interne expirée)",
                         tags: ["CRA"],
                         issues: [854],
                    },
                    {
                         text: "Demande d'embauche : le contrôle d'accès repose désormais sur la permission dédiée et non plus sur le rôle de l'utilisateur",
                         tags: ["Recrutement", "Sécurité"],
                         issues: [859],
                    },
               ],
          },
          internal: {
               functional: [
                    {
                         text: "Ajouter un staff : formulaire en plusieurs étapes avec provisionnement Google automatique (création du compte, rattachement aux groupes GWS)",
                         tags: ["Staff", "Google Workspace"],
                         issues: [847],
                    },
                    {
                         text: "Ajouter un staff : création automatique d'un Drive partagé au nom du staff, partagé au groupe du responsable",
                         tags: ["Staff", "Drive"],
                         issues: [849],
                    },
                    {
                         text: "Ajouter un staff : génération automatique de la signature Gmail à partir du modèle officiel (poste accordé au genre, email et téléphone)",
                         tags: ["Staff", "Gmail"],
                         issues: [850],
                    },
                    {
                         text: "Récapitulatif des ressources Google créées à la fin de l'ajout d'un staff + note de préparation du matériel (PC & portable) à prévoir avant l'arrivée",
                         tags: ["Staff", "Google Workspace"],
                         issues: [851],
                    },
                    {
                         text: "Activation / désactivation du compte directement depuis les items du listing staff (plus besoin d'ouvrir la fiche)",
                         tags: ["Staff"],
                         issues: [852],
                    },
                    {
                         text: "Mot de passe applicatif renseignable à la création du staff + email d'identifiants enrichi présentant les deux modes de connexion (identifiant/mot de passe et SSO Google)",
                         tags: ["Staff", "Sécurité", "Emails"],
                         issues: [855],
                    },
                    {
                         text: "Réinitialisation du mot de passe d'un staff depuis sa fiche ou le listing (génération automatique ou saisie manuelle), avec envoi des identifiants par email",
                         tags: ["Staff", "Sécurité"],
                         issues: [856],
                    },
                    {
                         text: "Checklist post-archivage : suivi des tâches Google à réaliser après un départ (export des données, archivage Drive, suppression des groupes et du compte) avec relance automatique par email",
                         tags: ["Staff", "Départ", "Google Workspace"],
                         issues: [861],
                    },
                    {
                         text: "Fiche staff : onglet « Documents » regroupant les déclarations d'activité mensuelles (navigation par année, statut de chaque déclaration, ouverture du détail et de l'historique du suivi)",
                         tags: ["Staff", "Déclarations"],
                         issues: [870],
                    },
                    {
                         text: "Nouvelle permission « Gestion staff (restreint) » : consultation des fiches staff sans les actions sensibles (mot de passe, activation/désactivation, sortie des effectifs) ni la modification des champs pro protégés, permissions et équipe",
                         tags: ["Staff", "Permissions"],
                         issues: [872],
                    },
                    {
                         text: "Fiche staff : nettoyage visuel — suppression des encarts non utilisés, email / téléphone / LinkedIn cliquables",
                         tags: ["Staff"],
                         issues: [871],
                    },
                    {
                         text: "Nouveau profil « Gestion staff (manager) » : un manager métier consulte uniquement les fiches de ses subordonnés (données sensibles masquées, lecture seule), gère l'équipe recrutement et la carte NFC, sans les actions sensibles",
                         tags: ["Staff", "Permissions"],
                         issues: [873],
                    },
                    {
                         text: "Ajouter un staff : les 3 niveaux d'accès (complet / restreint / manager) sont désormais sélectionnables, et la capacité « Ajouter Staff » se cumule librement avec l'un d'eux",
                         tags: ["Staff", "Permissions"],
                         issues: [874],
                    },
               ],
               technical: [
                    {
                         text: "Fiche staff : correction d'une fuite potentielle des déclarations (l'endpoint renvoyait les déclarations de l'utilisateur connecté au lieu du collaborateur consulté)",
                         tags: ["Staff", "Sécurité"],
                         issues: [869],
                    },
                    {
                         text: "Sécurisation de l'endpoint de création de staff (aucun contrôle d'accès auparavant — désormais réservé au droit « Ajouter Staff » / direction)",
                         tags: ["Staff", "Sécurité"],
                         issues: [874],
                    },
                    {
                         text: "Migration du serveur de production vers une infrastructure neuve « phoenix » (Debian 13 « Trixie ») en remplacement de l'ancien serveur CentOS 7 en fin de vie : socle plus sûr, plus rapide et maintenu pour des années. Code déployé et opérationnel sur le nouveau serveur ; bascule DNS finale planifiée le week-end du 22/08 (le domaine pointe encore vers l'ancien serveur d'ici là) — sans interruption de service côté utilisateurs (34.163.6.137 → 34.155.155.173)",
                         tags: ["Infra", "Prod", "Sécurité", "Performance"],
                         issues: [862],
                    },
                    {
                         text: "Montée du socle applicatif vers Symfony 6.4 LTS (l'ancienne version 6.3 n'était plus maintenue depuis janvier 2024) + remise à niveau des dépendances vulnérables (twig, dompdf, google/php-jwt, guzzle, carbon…) : les alertes de sécurité connues passent de 76 à 5, support de sécurité assuré jusqu'en novembre 2027",
                         tags: ["Infra", "Sécurité", "Symfony"],
                         issues: [865],
                    },
                    {
                         text: "Ajout d'un filet de tests automatisés (« smoke tests ») et câblage de l'environnement de test, pour sécuriser les montées de version et les changements de configuration (le projet n'avait aucun test jusque-là)",
                         tags: ["Infra", "Qualité", "Tests"],
                         issues: [864],
                    },
                    {
                         text: "Confort développeur : les changements de routes / métadonnées API Platform sont pris en compte immédiatement en dev, sans avoir à vider le cache",
                         tags: ["DX"],
                         issues: [866],
                    },
                    {
                         text: "CEGEDIM : journalisation du payload/réponse et échec bruyant en cas de rejet des écritures",
                         tags: ["Infra", "CEGEDIM"],
                         issues: [839],
                    },
                    {
                         text: "Freeze OOM prod du 24/07 : redimensionnement du pool PHP-FPM et ajout de limites mémoire conteneur",
                         tags: ["Infra", "Prod"],
                         issues: [840],
                    },
                    {
                         text: "Parsing PDF à l'upload de CV : déport/garde-fou mémoire (à l'origine du OOM du 24/07)",
                         tags: ["Infra", "Performance"],
                         issues: [841],
                    },
                    {
                         text: "Sortie des secrets OAuth Google (GWS + Drive) du dépôt vers des variables d'environnement",
                         tags: ["Sécurité", "Infra"],
                         issues: [848],
                    },
                    {
                         text: "Synchronisation Google Calendar non imposée en environnement de développement",
                         tags: ["DX"],
                         issues: [858],
                    },
               ],
          },
     },
     {
          id: 4,
          version: "v8.3.0",
          date: "13/07/2026",
          title: "Demandes d'embauche & sous-traitance",
          changes: {
               feature: [],
               improvement: [
                    {
                         text: "Demande d'embauche portage / société de service : l'email du futur collaborateur est désormais saisi dans le formulaire (plus d'adresse provisoire générée automatiquement)",
                         tags: ["Recrutement"],
                    },
                    {
                         text: "Demande de rectification d'une déclaration : les administrateurs fournisseur sont notifiés pour les consultants en société de service (les freelances sont notifiés directement)",
                         tags: ["Déclarations", "Espace fournisseur"],
                    },
               ],
               fix: [
                    {
                         text: "Correction du formulaire de modification des coordonnées dans l'espace consultant freelance qui était bloqué et pouvait effacer l'adresse enregistrée",
                         tags: ["Espace consultant"],
                    },
                    {
                         text: "Message d'erreur clair lorsque l'email saisi dans une demande d'embauche appartient déjà à un autre compte (au lieu d'une erreur technique)",
                         tags: ["Recrutement"],
                    },
                    {
                         text: "Déclarations des consultants en société de service : l'onglet « Factures de prestation » est désormais sélectionné par défaut comme pour le portage",
                         tags: ["Déclarations"],
                    },
               ],
          },
          internal: {
               technical: [
                    {
                         text: "Demande d'embauche : garde-fous contre l'écrasement du rôle d'un compte existant + journalisation de sécurité",
                         tags: ["Sécurité", "Recrutement"],
                         issues: [837],
                    },
               ],
          },
     },
     {
          id: 3,
          version: "v8.2.0",
          date: "09/07/2026",
          title: "Espace fournisseur & corrections",
          changes: {
               feature: [],
               improvement: [
                    {
                         text: "Message d'erreur détaillé selon le type d'utilisateur (personnel interne, consultant, candidat, responsable fournisseur) lorsqu'une adresse mail est déjà utilisée à la création d'un responsable fournisseur",
                         tags: ["Espace fournisseur"],
                    },
                    {
                         text: "Espace fournisseur : affichage dédié avec bouton d'actualisation lorsqu'aucun collaborateur n'est rattaché",
                         tags: ["Espace fournisseur"],
                    },
                    {
                         text: "Mention de la validité de 24h ajoutée aux emails d'instructions de connexion (consultants et responsables fournisseur)",
                         tags: ["Emails"],
                    },
                    {
                         text: "Espace fournisseur : tous les collaborateurs sont désormais visibles dans le listing, y compris ceux en cours d'embauche",
                         tags: ["Espace fournisseur"],
                    },
               ],
               fix: [
                    { text: "Correction de l'animation qui se rejouait sur les notes de frais à chaque ouverture/fermeture de justificatif", tags: ["Déclarations"] },
                    { text: "Correction de la validation des demandes d'embauche par la direction qui passait par le mauvais circuit de validation", tags: ["Recrutement"] },
                    { text: "Affichage des alertes d'activation de compte et d'instructions de connexion pour les consultants freelance", tags: ["Business"] },
                    { text: "Correction du délai de republication mentionné dans les emails d'annonces (20 jours au lieu de 15)", tags: ["Recrutement", "Annonce", "Emails"] },
                    { text: "Contrôle d'unicité de l'adresse mail lors de la modification d'un collaborateur par un responsable fournisseur", tags: ["Espace fournisseur"] },
                    { text: "Correction de l'indicatif téléphonique qui ne s'enregistrait pas lors de la modification d'un collaborateur", tags: ["Espace fournisseur"] },
               ],
          },
          internal: {
               technical: [
                    {
                         text: "Déploiement staging : persistance des clés JWT, intégration du composer install dans l'image, nettoyage des résidus docker",
                         tags: ["Infra", "CI/CD"],
                         issues: [832],
                    },
               ],
          },
     },
     {
          id: 2,
          version: "v8.1.0",
          date: "30/06/2026",
          title: "Espace fournisseur, déclarations & corrections",
          changes: {
               feature: [
                    {
                         text: "Mise à jour automatique des coûts collaborateurs à partir des données réelles du logiciel de paie",
                         tags: ["Business", "Paie"],
                    },
                    {
                         text: "Validation en masse des déclarations",
                         tags: ["Déclarations"],
                    },
                    {
                         text: "Téléchargement des déclarations : PDF unique fusionné (récapitulatif + annexes) pour les salariés ; PDF groupé (factures de prestation + factures de frais) pour les sous-traitants",
                         tags: ["Déclarations"],
                    },
                    {
                         text: "Espace fournisseur : extraction automatique du montant HT et de la TVA lors du dépôt des bons de livraison / livrables",
                         tags: ["Espace fournisseur"],
                    },
               ],
               improvement: [
                    {
                         text: "Diverses améliorations dans l'espace fournisseur",
                         tags: ["Espace fournisseur"],
                    },
                    {
                         text: "Fiche collaborateur : les ordres de mission actifs sont affichés en premier avec un tag dédié",
                         tags: ["Business"],
                    },
                    {
                         text: "Autorisation des tickets restaurant (TR) pendant les jours de formation",
                         tags: ["Business"],
                    },
                    {
                         text: "Republication manuelle des annonces remplacée par une republication automatique tous les 20 jours",
                         tags: ["Recrutement", "Annonce"],
                    },
                    {
                         text: "Notification mail de republication étendue à toute annonce non republiée depuis plus d'une semaine",
                         tags: ["Recrutement", "Annonce"],
                    },
                    {
                         text: "Lors d'une demande de rectification par un responsable CTS, le responsable fournisseur et les administrateurs fournisseur reçoivent également un email (administrateurs en copie)",
                         tags: ["Déclarations", "Espace fournisseur"],
                    },
                    {
                         text: "Amélioration de l'échelle du graphique d'évolution des effectifs pour une meilleure lisibilité des petites variations",
                         tags: ["Tableau de bord", "KPI"],
                    },
               ],
               fix: [
                    { text: "Correction de plusieurs liens cassés dans les emails", tags: ["Emails"] },
                    { text: "Correction des problèmes d'extraction de factures dans l'espace fournisseur", tags: ["Espace fournisseur"] },
                    { text: "Correction des demandes d'embauche fantômes apparaissant dans la liste", tags: ["Recrutement"] },
                    { text: "Correction des actions non fonctionnelles sur les demandes d'embauche", tags: ["Recrutement"] },
                    { text: "Correction des problèmes de permissions pour certains utilisateurs", tags: ["Administration"] },
                    { text: "Correction de l'email non envoyé pour les collaborateurs absents de la synchronisation paie", tags: ["Paie", "Emails"] },
                    { text: "Correction de la recherche de ville sans historique dans le listing candidats", tags: ["Recrutement"] },
                    { text: "Correction de l'affichage incorrect dans l'export comptable après modification du numéro analytique", tags: ["Business", "Export"] },
                    { text: "Correction du bug d'affichage des bons de livraison manquants", tags: ["Business"] },
                    { text: "Correction du bug lors du changement de mot de passe", tags: ["Compte"] },
                    { text: "Correction du bug de signature des déclarations du personnel", tags: ["Déclarations"] },
                    { text: "Correction du bouton valider/rejeter non visible pour les responsables sur les demandes de régularisation", tags: ["Déclarations"] },
                    { text: "Correction du bug d'édition groupée des notes de frais lors de l'ajout d'indemnités kilométriques (IK)", tags: ["Déclarations"] },
                    { text: "Correction du filtre responsable par défaut (notamment dans la section recrutement)", tags: ["Recrutement"] },
                    { text: "Correction de la double invitation envoyée lors de la planification de réunions avec plusieurs participants internes", tags: ["Recrutement"] },
                    { text: "Correction du calcul du chiffre d'affaires pour les collaborateurs ayant changé de mission en cours de période", tags: ["KPI", "Business"] },
               ],
          },
     },
     {
          id: 1,
          version: "v8.0.0",
          date: "04/05/2026",
          title: "Refonte du Tableau de Bord & Optimisation Recrutement",
          changes: {
               feature: [
                    {
                         text: "Intégration des KPIs globaux: rentabilité et évolution des effectifs accesibles depuis le tableau de bord.",
                         tags: ["Tableau de bord", "KPI"],
                    },
                    {
                         text: "Intégration des KPI relatifs à chaque collaborateur accessibles depuis l'onglet 'indicateurs' de la fiche du consultant.",
                         tags: ["Tableau de bord", "KPI", ""],
                    },
                    { text: "Journal des mises à jour afin que vous soyez au courant des derniers changements", tags: ["Changelog"] },
                    { text: "Import de CV : analyse automatique et récupération des données clés (nom, email, tél...)", tags: ["Recrutement", "Candidat"] },
                    { text: "Possibilité de lier une annonce spécifique depuis le suivi d'un candidat", tags: ["Recrutement", "Annonce"] },
                    {
                         text: "Système de 'ressenti' afin d'évaluer l'issue des entretiens. Disponible pour le moment lors d'une DMS ou un entretien en agence / visio.",
                         tags: ["Recrutement", "Candidat"],
                    },
                    { text: "Mise en place d'un système de Blacklisting pour les candidats non recommandés", tags: ["Recrutement", "Candidat"] },
                    { text: "Notification mail automatique lors de la complétion du dossier d'embauche par le candidat", tags: ["Recrutement", "Espace candidat"] },
               ],
               improvement: [
                    {
                         text: "Indemnités kilométriques : intégration d'un calendrier interactif pour le choix des jours et rendu dans le récapitulatif PDF",
                         tags: ["Déclarations"],
                    },
                    { text: "Échanges : fusion des commentaires et suivis sous un système unique et centralisé", tags: ["Recrutement", "Candidat"] },
                    { text: "Gestion flexible des rémunérations : basculement Brut/Net/HT et périodicités Annuel/Mensuel/Journalier", tags: ["Recrutement", "Candidat"] },
                    {
                         text: "Optimisation de la planification de réunions",
                         tags: ["Recrutement", "Candidat"],
                    },
                    { text: "Filtres avancés pour les candidats : filtrage par suivi, responsable et date précise ainsi que par blacklist", tags: ["Recrutement"] },
                    { text: "Accès et téléchargement des documents d'embauche directement depuis la fiche collaborateur", tags: ["Business"] },
                    { text: "Accélération de la republication automatique des annonces (passage de 2 semaines à 1 semaine)", tags: ["Recrutement", "Annonce"] },
                    { text: "Ajout du champ téléphone lors de l'import manuel d'un candidat", tags: ["Recrutement"] },
               ],
               fix: [{ text: "Mise à jour dynamique du statut de suivi lors de l'ajout d'un nouvel échange", tags: ["Recrutement"] }],
          },
     },
]
